import React from "react";
import { styled } from "@linaria/react";
import FileIcon from "@assets/images/file-icon.png";
import { Text } from "../Text";
import ProgressBar from "./ProgressBar";
import { useAvivaDispatch } from "@redux/hook";
import {
  uploadStatus,
  retryUploadFiles,
} from "@redux/slices/SHIELD_STARTER/step3Slice";
import { DOWNLOAD_DOCUMENT_DATA, getBaseURLNew } from "@api/index";
import { css } from "@linaria/core";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px;
  gap: 24px;
  border-radius: 8px;
  border: 1px solid #f5f5f5;
  margin-top: 5px;
`;

const FileContinaer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const TextContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

const OverflowCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  cursor: pointer;
`;

const FileUploadCard = ({ file, deleteFile, retryFile }: any) => {
  const dispatch = useAvivaDispatch();

  const cancelUpload = () => {
    if (!file.cancelSource) return;
    file.cancelSource.cancel("Cancelled by user");
  };

  const handleFileClick = (id: number) => {
    if (!id) return;

    window.open(
      `${getBaseURLNew()}${DOWNLOAD_DOCUMENT_DATA}/${id}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Container>
      <FileContinaer>
        {file.status === uploadStatus.SUCCESS && (
          <img
            width="30px"
            height="30px"
            src={FileIcon}
            alt={"info-icon"}
            style={{ marginRight: "8px" }}
          />
        )}

        <TextContainer onClick={() => handleFileClick(file.attachmentId)}>
          <Text variant="base" fontWeight={500} textClass={OverflowCss}>
            {file.fileName}
          </Text>
        </TextContainer>
        <ActionContainer>
          {file.status === uploadStatus.FAILED && !file.attachmentId && (
            <div
              onClick={() => {
                dispatch(retryUploadFiles(file.id));
                retryFile(file);
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Control/Renew">
                  <path
                    id="Union"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.48233 6.99067C8.62052 7.2383 8.97222 7.24904 9.12519 7.01029L11.2375 3.71343C11.3952 3.46741 11.2244 3.14317 10.9328 3.13477L6.91604 3.01896C6.62497 3.01057 6.43583 3.32332 6.57795 3.57801L7.0107 4.35349C7.05488 4.43266 7.01629 4.53231 6.94193 4.58404C4.55546 6.24417 3 8.9503 3 12.0073C3 15.5797 5.12329 18.6723 8.21681 20.178C8.56775 20.3488 8.9808 20.1756 9.13501 19.8164C9.29525 19.4433 9.11474 19.0138 8.7534 18.8297C6.21601 17.5362 4.48857 14.9656 4.48857 12.0073C4.48857 9.48698 5.74191 7.24842 7.68295 5.84049C7.73979 5.79926 7.82357 5.81017 7.85782 5.87154L8.48233 6.99067ZM16.1422 18.1661C16.1764 18.2275 16.2602 18.2384 16.3171 18.1972C18.2581 16.7892 19.5114 14.5507 19.5114 12.0303C19.5114 9.07202 17.784 6.50142 15.2466 5.20798C14.8853 5.02379 14.7047 4.59437 14.865 4.22121C15.0192 3.86208 15.4322 3.6888 15.7832 3.85961C18.8767 5.36536 21 8.45795 21 12.0303C21 15.0873 19.4445 17.7935 17.0581 19.4536C16.9837 19.5053 16.9451 19.605 16.9893 19.6841L17.422 20.4596C17.5642 20.7143 17.375 21.027 17.084 21.0186L13.0672 20.9028C12.7756 20.8944 12.6048 20.5702 12.7625 20.3242L14.8748 17.0273C15.0278 16.7886 15.3795 16.7993 15.5177 17.0469L16.1422 18.1661Z"
                    fill="#434343"
                  />
                </g>
              </svg>
            </div>
          )}
          <div
            onClick={() =>
              file.status === uploadStatus.UPLOADING
                ? cancelUpload()
                : deleteFile(file.id, file.attachmentId)
            }
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L13.5303 12.4697C13.8232 12.7626 13.8232 13.2374 13.5303 13.5303C13.2374 13.8232 12.7626 13.8232 12.4697 13.5303L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z"
                fill="#434343"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.5303 0.46967C13.8232 0.762563 13.8232 1.23744 13.5303 1.53033L1.53033 13.5303C1.23744 13.8232 0.762563 13.8232 0.46967 13.5303C0.176777 13.2374 0.176777 12.7626 0.46967 12.4697L12.4697 0.46967C12.7626 0.176777 13.2374 0.176777 13.5303 0.46967Z"
                fill="#434343"
              />
            </svg>
          </div>
        </ActionContainer>
      </FileContinaer>
      {file.status === uploadStatus.FAILED && (
        <div>
          <Text variant="base" color="#C50000" fontWeight={600} fontSize="12px">
            {file.error}
          </Text>
          <hr
            style={{
              backgroundColor: "#C50000",
              fontWeight: 600,
              height: "3px",
              border: "none",
              marginTop: "2px",
            }}
          />
        </div>
      )}
      {[
        uploadStatus.UPLOADING,
        uploadStatus.INACTIVE,
        uploadStatus.QUEUE,
      ].includes(file.status) && <ProgressBar progress={file.progress} />}
    </Container>
  );
};

export default FileUploadCard;
